import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { changeRequestorMsg, customerMsg, statusMsg, t, topicMsg } from '../../common/i18n';
import { CustomerOrderType } from '../../generated/api/models.js';
import { useConfig } from '../../public/site/ConfigProvider';
import { getTopicText } from '../CustomerOrderList/customerOrderUtils.js';
import { Status } from '../Status/Status.js';
import { getCustomerOrderStatusInfo } from './CustomerOrderDetailsUtil.js';
import type { CLDescriptionItem } from '../../common/types/componentLibrary.js';
import type { CustomerOrder } from '../../generated/api/models.js';

interface OECOrderInfoProps {
  customerOrder: CustomerOrder;
  customerOrderDescription?: string;
}

export const OECOrderInfo = ({ customerOrder, customerOrderDescription }: OECOrderInfoProps) => {
  const config = useConfig();
  const statusInfo = getCustomerOrderStatusInfo(customerOrder.status);
  const isChangeRequest = customerOrder.customerOrderType === CustomerOrderType.CHANGE_REQUEST;

  const fields: CLDescriptionItem[] = [
    {
      title: t.ASQT(statusMsg),
      description: <Status color={statusInfo.color} textAfterBadge={statusInfo.text} />,
    },
  ];

  if (customerOrder.customerOrderContact?.trim()) {
    fields.push({
      title: isChangeRequest ? t.C8M7(changeRequestorMsg) : t.IY5V(customerMsg),
      description: customerOrder.customerOrderContact,
    });
  }

  if (isChangeRequest && customerOrder.orderTopic?.trim()) {
    fields.push({
      title: t.JJTS(topicMsg),
      description: getTopicText(customerOrder.orderTopic),
    });
  }

  const detailsTitle = isChangeRequest ? t.E9BD('Details of the change') : t.KDIV('Details of the order');

  return (
    <div>
      <div className="of-customer-order-details__oec-order of-customer-order-details__oec-order-info-banner">
        {t.ECIT('The order can be tracked also by using the')}&nbsp;
        <a href={`${config.classicSiteUrl}/tilaushistoria`}>{t.RR0O('OmaElisa Classic.')}</a>
      </div>
      <CL.Description items={fields} className={dsClass.PADDING_BOTTOM_3} />
      <hr className={dsClass.BORDER_TOP_WIDTH_0} />
      {customerOrderDescription && (
        <>
          <h3 className={`${dsClass.MARGIN_BOTTOM_5} ${dsClass.MARGIN_TOP_6}`}>{detailsTitle}</h3>
          <div className="of-customer-order-details__oec-order of-customer-order-details__oec-order-description">
            {customerOrderDescription.trimEnd()}
          </div>
        </>
      )}
    </div>
  );
};
